/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_12_DInputs */

const en_tut_gl_12_d = /** @type {(inputs: Tut_Gl_12_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice from the people closest to you in the same area. Never recorded, never transcribed, and only on when you choose it.`)
};

const id_tut_gl_12_d = /** @type {(inputs: Tut_Gl_12_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suara dari rekan terdekat di area yang sama. Tidak direkam, tidak ditranskripsi, dan hanya menyala kalau Anda memilihnya.`)
};

/**
* | output |
* | --- |
* | "Voice from the people closest to you in the same area. Never recorded, never transcribed, and only on when you choose it." |
*
* @param {Tut_Gl_12_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_12_d = /** @type {((inputs?: Tut_Gl_12_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_12_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_12_d(inputs)
	return en_tut_gl_12_d(inputs)
});